module.exports = __webpack_public_path__ + "static/media/prizeInstance.24ea067f.svg";